import { render, staticRenderFns } from "./TakeABreak.vue?vue&type=template&id=253fc14e&"
import script from "./TakeABreak.vue?vue&type=script&lang=js&"
export * from "./TakeABreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports